import { css } from '@emotion/react';

export const containerStyle = css`
  min-width: 32px;
  min-height: 32px;
  align-items: center;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;
